module.exports = __webpack_public_path__ + "img/time-and-calendar.cca530e4.png";